export default {"src":"/_next/static/media/c2c-financing.906d7210.svg","height":252,"width":337,"blurWidth":0,"blurHeight":0};